.button {
  border-radius: 0;
}

.container {
  display: inline-block;
}
